import { EngagementVehicle } from '../../../types/services';

export const iconMapping = (vehicleType: string) => {
    type icons = {
        [key: string]: {
            svgIcon: string;
        };
    };
    const iconMapping: icons = {
        bus: {
            svgIcon: 'van'
        },
        campingvgn: {
            svgIcon: 'caravan'
        },
        knallert: {
            svgIcon: 'scooter'
        },
        motorcykel: {
            svgIcon: 'mc'
        },
        personbil: {
            svgIcon: 'car2'
        },
        traktor: {
            svgIcon: 'tractor'
        },
        varelastbi: {
            svgIcon: 'truck'
        },
        others: {
            svgIcon: 'wheel'
        }
    };
    return iconMapping[vehicleType].svgIcon;
};
export const OTHERS = 'others';
export const mapToOptions = (data: EngagementVehicle[] | undefined) => {
    type VehicleOption = {
        value: string;
        entity: EngagementVehicle['entity'] | typeof OTHERS;
        description: string;
        registrationNumber: string;
    };

    const options: VehicleOption[] = [];

    if (Array.isArray(data)) {
        data.forEach((vehicleData) => {
            options.push({
                value: vehicleData.policyNumber,
                entity: vehicleData.entity,
                description: vehicleData.description,
                registrationNumber: vehicleData.registrationNumber
            });
        });
    }
    options.push({
        value: OTHERS,
        entity: OTHERS,
        description: 'Andet',
        registrationNumber: ''
    });
    return options;
};
